import { customAxios } from "../../axios/CustomAxios";
import {myIpAddress} from "../../config";

// 전체 유저 리스트(직급별,입사일자, 우선순위 정렬)
const userAll =()=>{
    return customAxios.get(myIpAddress+'/user/all');
}
export default userAll;